var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailConfirmedSuccessArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 41,
    viewBox: "0 0 67 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.7558 32.6424L61.3414 0.632009C62.391 -0.399105 64.366 -0.141701 65.7527 1.20829C67.1394 2.55827 67.4115 4.48848 66.3618 5.51959L30.8869 40.3683C30.1656 41.0769 29.0078 41.1766 27.9041 40.7315C27.4457 40.6501 27.0313 40.4518 26.7047 40.1311L0.649822 18.5861C-0.417757 17.5374 -0.141091 15.5762 1.26795 14.2045C2.677 12.8327 4.68364 12.571 5.75121 13.6197L28.7558 32.6424Z",
    fill: "url(#paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 31.4903,
    y1: -29.7738,
    x2: 70.6938,
    y2: 40.7144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92D142"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503996,
    stopColor: "#34AF20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.983171,
    stopColor: "#09955A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailConfirmedSuccessArrow);
export default __webpack_public_path__ + "static/media/email-confirmed-success-arrow.d0324c2f.svg";
export { ForwardRef as ReactComponent };